import { render } from "./ChartcontrollerSetting.vue?vue&type=template&id=5cfd5dbf&scoped=true"
import script from "./ChartcontrollerSetting.vue?vue&type=script&lang=js"
export * from "./ChartcontrollerSetting.vue?vue&type=script&lang=js"

import "./ChartcontrollerSetting.vue?vue&type=style&index=0&id=5cfd5dbf&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cfd5dbf"]])

export default __exports__